export const ADMIN_ACTIONS = {
  OVERVIEW_VIEW: 'admin.overview.view',
  TENANT_VIEW: 'admin.tenant.view',
  TENANT_EDIT: 'admin.tenant.edit',
  TENANT_STATUS: 'admin.tenant.status',
  USER_VIEW: 'admin.user.view',
  USER_EDIT: 'admin.user.edit',
  USER_STATUS: 'admin.user.status',
  USER_RESET_PASSWORD: 'admin.user.reset_password',
  ENVIRONMENT_VIEW: 'admin.environment.view',
  PROXY_VIEW: 'admin.proxy.view',
  PROXY_INVENTORY_EDIT: 'admin.proxy_inventory.edit',
  NURTURE_VIEW: 'admin.nurture.view',
  NURTURE_CONTROL: 'admin.nurture.control',
  PUBLISH_VIEW: 'admin.publish.view',
  PUBLISH_CONTROL: 'admin.publish.control',
  RISK_VIEW: 'admin.risk.view',
  RISK_HANDLE: 'admin.risk.handle',
  INTEL_VIEW: 'admin.intel.view',
  INTEL_CREATE: 'admin.intel.create',
  INTEL_EDIT: 'admin.intel.edit',
  INTEL_DELETE: 'admin.intel.delete',
  SECURITY_VIEW: 'admin.security.view',
  ORDER_VIEW: 'admin.order.view',
  ORDER_CONTACT: 'admin.order.contact',
  ORDER_CONFIRM_PAYMENT: 'admin.order.confirm_payment',
  ORDER_DELIVER: 'admin.order.deliver',
  ORDER_CANCEL: 'admin.order.cancel',
  PROXY_PRODUCT_VIEW: 'admin.proxy_product.view',
  PROXY_PRODUCT_EDIT: 'admin.proxy_product.edit',
  PLAN_VIEW: 'admin.plan.view',
  PLAN_CREATE: 'admin.plan.create',
  PLAN_EDIT: 'admin.plan.edit',
  PLAN_STATUS: 'admin.plan.status',
  PLAN_DELETE: 'admin.plan.delete',
  TEAM_SEAT_PRODUCT_VIEW: 'admin.team_seat_product.view',
  TEAM_SEAT_PRODUCT_EDIT: 'admin.team_seat_product.edit',
  TEAM_SEAT_GRANT: 'admin.team_seat.grant',
  SUBSCRIPTION_VIEW: 'admin.subscription.view',
  SUBSCRIPTION_GRANT: 'admin.subscription.grant',
  SUBSCRIPTION_RENEW: 'admin.subscription.renew',
  SUBSCRIPTION_CANCEL: 'admin.subscription.cancel',
  INVOICE_VIEW: 'admin.invoice.view',
  INVOICE_REMIND: 'admin.invoice.remind',
  INVOICE_EXPORT: 'admin.invoice.export',
  FINANCE_VIEW: 'admin.finance.view',
  ADMIN_USER_VIEW: 'admin.operator.view',
  ADMIN_USER_CREATE: 'admin.operator.create',
  ADMIN_USER_EDIT: 'admin.operator.edit',
  ADMIN_USER_STATUS: 'admin.operator.status',
  ADMIN_USER_DELETE: 'admin.operator.delete',
  SETTINGS_VIEW: 'admin.settings.view',
  SETTINGS_EDIT: 'admin.settings.edit',
  EXPORT_VIEW: 'admin.export.view',
  EXPORT_CREATE: 'admin.export.create',
  EXPORT_RETRY: 'admin.export.retry',
  EXPORT_DELETE: 'admin.export.delete',
  NOTIFICATION_VIEW: 'admin.notification.view',
  NOTIFICATION_RETRY: 'admin.notification.retry',
  SUPPORT_VIEW: 'admin.support.view',
  SUPPORT_REPLY: 'admin.support.reply',
  FAQ_VIEW: 'admin.faq.view',
  FAQ_EDIT: 'admin.faq.edit',
} as const

export type AdminActionCode = typeof ADMIN_ACTIONS[keyof typeof ADMIN_ACTIONS]
